module.exports = __webpack_public_path__ + "assets/fc80394f0f94885e1ab91d8227aca777.mp3";